<template>
    <div class="">
        <Backer class="hidden-print" v-if="!viewdata"/>

        <div class="">
            <b-overlay :show="pullist_being_loaded" rounded="sm"
                <div v-if="pullist.length > 0">
                    <b-card-group deck>
                    <b-card bg-variant="light" :header="pullist[0].name" class="text-left">
                    <!-- <div style="background: #efefef; width: auto; display: inline-block; padding: 5px; font-size: 14px; margin: 5px; margin: 10px;"> -->
                        <div>Name: {{pullist[0].name }}</div>
                        <!-- <div>Truck: {{pullist[0].truckname}}</div> -->
                        <div>Created: {{ pullist[0].datetime }}</div>
                        <div>Delivery To: {{ locationsdict[pullist[0].location_id] }}</div>
                        <div>
                            Pulling From: 
                            <b-form-select
                                v-model="picked_location"
                                :options="locations"
                                size="sm"
                                variant="outline-primary"
                                style="width: 150px; display: inline-block;"
                                v-on:change="filterFromLocation"
                            ></b-form-select>
                        </div>


                    <!-- </div> -->
                    </b-card>
                    </b-card-group>
                    <!-- <div style="background: #efefef; width: 200px; display: inline-block; padding: 5px; font-size: 12px; margin: 5px; margin: 10px;">
                        Please write truck # <b> ( {{pullist[0].truckname}} )</b> on all the items pulled for this pullist.
                    </div> -->

                    <div>
                        <div>
                            <table style="width: 100%;">
                                <thead>
                                    <tr style="background: black; color: white;">
                                        <!-- <td class="ipt_tdhr" v-on:click="sortby('request_date')">
                                            REQ DATE
                                        </td>
 -->
                                        <td class="ipt_tdhr">
                                            PRD
                                        </td>

                                        <td class="ipt_tdhr" v-on:click="sortby('source_location_id')">
                                            PULL FROM
                                        </td>

                                        <td class="ipt_tdhr" v-on:click="sortby('location_id')">
                                            DELIVER TO
                                        </td>

                                        <td class="ipt_tdhr">
                                            RQ
                                        </td>

                                        <td class="ipt_tdhr">
                                            AQ
                                        </td>

                                        <td class="ipt_tdhr">
                                            PQ
                                        </td>

                                        <td class="ipt_tdhr">
                                            PULLED BY
                                        </td>

                                        <!-- <td class="ipt_tdhr" v-on:click="sortby('pull_location_id')">
                                            STAGED AT
                                        </td> -->

                                        <td class="ipt_tdhr" v-on:click="sortby('status')">
                                            STATUS
                                        </td>

                                        <td class="ipt_tdhr">
                                            Action
                                        </td>

                                    </tr>
                                </thead>


                                <tbody>
                                    <tr v-for="plitem, idx in pullist" v-if="showRow(idx)">
                                        <!-- <td class="ipt_tdr" style="width: 80px;">
                                            {{ plitem.request_date }}
                                        </td> -->

                                        <td class="ipt_tdr" style="background: #ebffeb;">
                                            <div style="font-weight: bold; padding: 4px;">{{ plitem.item.product_sku }}</div>
                                            <div>{{ plitem.vendor }} ({{ plitem.category }})</div>
                                            <b-badge variant="success" v-if="plitem.invoice_id">sale # {{ plitem.invoice_id}}</b-badge>
                                        </td>

                                        <td class="ipt_tdr">
                                            <div>{{ locationsdict[plitem.source_location_id] }}</div>
                                            <div>{{ sublocationsdict[plitem.source_sublocation_id] }}</div>
                                        </td>

                                        <td class="ipt_tdr" >
                                            <div>{{ locationsdict[plitem.location_id] }}</div>
                                            <div>{{ sublocationsdict[plitem.sublocation_id] }}</div>
                                        </td>

                                        <td class="ipt_tdr" style="width: 25px;">
                                            {{ plitem.requested_quantity }}
                                        </td>

                                        <td class="ipt_tdr" style="width: 25px; background: #ebffeb;">
                                            {{ plitem.approved_quantity }}
                                        </td>

                                        <td class="ipt_tdr">
                                            <input v-model="plitem.pulled_quantity" :style="{width: '30px', 'background': (( plitem.pulled_quantity == null || plitem.pulled_quantity == '') ? '#fdcb6e' : 'orange'), 'border': '1px solid #efefef', 'padding': '3px'}"></input>
                                        </td>

                                        <td class="ipt_tdr">
                                            <div>{{plitem.pulled_by}}</div>
                                            <div style="font-size: 12px;">{{plitem.pulled_ts}}</div>
                                        </td>

                                        <!-- <td class="ipt_tdr">
                                            <b-form-select
                                                v-model="plitem.pull_locsub"
                                                :options="locsubs"
                                                size="sm"
                                                variant="outline-primary"
                                                style="width: 150px; display: inline-block;"
                                            ></b-form-select>
                                        </td> -->

                                        <td class="ipt_tdr" :style="{background: tr_item_statuses_colors[plitem.status] }">
                                            {{ tr_item_statuses_dict[plitem.status] }}
                                        </td>

                                        <td class="ipt_tdr">
                                            <span v-if="plitem.status == 1">
                                                <b-button size="sm" variant="success" style="padding: 1px; cursor: pointer; font-size: 14px; font-weight: bold;" :disabled="is_action_disabled" @click="markPullistItemReady(idx)">Mark Pulled</b-button>
                                            </span>
                                            <span v-else-if="plitem.status == 3">
                                                <b-button size="sm" variant="success" style="padding: 1px; cursor: pointer; font-size: 14px; font-weight: bold;" :disabled="is_action_disabled" @click="markPullistItemReady(idx)">Update</b-button>
                                            </span>
                                            <span v-else>

                                            </span>
                                        </td>
                                       
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </b-overlay>
        </div>

    </div>

</template>

<script>
    import global_vars from "@/utilities/global_vars"
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'

    export default {
        name: "ViewPullist",
        props: ["viewdata"],
        components: {Backer},
        data: function(){
            let out = {
                userDetails: {properties: {}},
                pullist: [],
                pullist_printable_data: [],
                pullist_name: null,
                request_types: [
                    {value: "transfer_for_display", text: "Store Transfer (for display)"},
                    {value: "transfer_for_pickup", text: "Store Transfer (for store pickup)"},
                    {value: "transfer_for_storage", text: "Store Transfer (for storage)"},
                    {value: "transfer_for_delivery", text: "Customer Transfer (for customer delivery)"}
                ],
                locsubs: [],
                locations: [],
                locationsdict: {},
                sublocations: [],
                sublocationsdict: {},
                tr_status: null,
                tr_item_statuses: global_vars.TRANSFER_STATUSES,
                tr_item_statuses_colors: global_vars.TRANSFER_STATUSES_COLORS_DICT,
                tr_item_statuses_dict: global_vars.TRANSFER_STATUSES_DICT,
                pullist_being_loaded: true,
                buffered: {},
                is_action_disabled: false,
                name: null,
                picked_location: null,
                sort_asc: true,
            };
            return out;
        },
        methods: {

            markPullistItemReady: function(idx){
                let that = this;
                let path = "/api/inventory/mark_tr_item_pulled/"
                let data = this.pullist[idx];
                data.pulled_by = this.userDetails.username;

                // if (!this.picked_location){
                //     this.$vex.dialog.alert({message: "Please pick a location from which the pullist is prepared (or `Pull From`)."});
                //     return
                // }

                if (!data.pull_locsub){
                    this.$vex.dialog.alert({message: "Please select `STAGED AT` location."});
                    return
                }
                else {
                    let splitted = data.pull_locsub.split("|").map(function(d){return +d });
                    if (splitted.length > 1){
                        let pull_location_id = splitted[0];
                        let pull_sublocation_id = splitted[1];

                        data.pull_location_id = pull_location_id;
                        data.pull_sublocation_id = pull_sublocation_id;
                    }
                }

                if (data.pulled_quantity == null || isNaN(parseInt( data.pulled_quantity )) ){
                    this.$vex.dialog.alert({message: "Please specify a valid quantity pulled."});
                    return
                }
                else {
                    data.pulled_quantity = parseInt(data.pulled_quantity);
                }

                if (data.pulled_quantity > data.approved_quantity){
                    this.$vex.dialog.alert({message: "# of items pulled cannot be more than approved."});
                    return
                }

                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Marked as PULLED!", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        that.pullist[idx].status = 3 
                    }
                    that.is_action_disabled = false;
                }

                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error occurred while updating TR Item. Please try again.", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.is_action_disabled = false;
                }

                this.is_action_disabled = true;
                Requestor.postAsyncP(path, data, this, s, f);
            },
            fetch_prereqs: function(){
                let that = this;
                let prereqs = [
                    {
                        path:  "/api/location/list_locations/",
                        data: {},
                        type: "",
                        executable: Requestor.getSync,
                        s: function(response){
                            if (response.data.result){
                                that.locations = response.data.result.map(function(d){
                                    return {value: d.id, text: d.name}
                                });
                                that.locations.splice(0, 0, {value: null,  text: "All"});
                                that.locationsdict = that.locations.reduce((map, obj) => (map[obj.value] = obj.text, map), {});
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error);
                            that.$bvToast.toast(
                                "Error loading locations.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                    {
                        path:  "/api/location/list_sublocations/",
                        data: {},
                        type: "",
                        executable: Requestor.getSync,
                        s: function(response){
                            if (response.data.result){
                                that.sublocations = response.data.result.map(function(d){
                                    return {value: d.id, text: d.name, location_id: d.location_id}
                                });
                                that.sublocationsdict = that.sublocations.reduce((map, obj) => (map[obj.value] = obj.text, map), {});

                                //after all is done, call fetch init.
                                that.fetch_init();
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            that.$bvToast.toast(
                                "Error loading sublocations.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                    {
                        path:  "/api/location/list_locations_sublocations/",
                        data: {},
                        type: "",
                        executable: Requestor.getSync,
                        s: function(response){
                            if (response.data.result){
                                that.locsubs = response.data.result;
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            that.$bvToast.toast(
                                "Error loading locations/sublocations.",
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                ]

                for (var i=0; i<prereqs.length; i++){
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure"){
                        prereqs[i]["executable"](path, data, this, s, f);   
                    }
                    else {
                        prereqs[i]["executable"](path, data, s, f); 
                    }
                }
            },
            fetch_init: function(){
                let that = this;
                let prereqs = [
                    {
                        path:  "/api/inventory/get_pullist/",
                        data: {name: this.name},
                        type: "secure",
                        executable: Requestor.getSyncP,
                        s: function(response){
                            if (response.data.result){
                                that.pullist = response.data.result;
                                if (that.locationsdict && that.sublocationsdict){
                                    that.pullist_printable_data = that.pullist.map(function(d){
                                    return {
                                        product_id: (d.item || {}).product_id,
                                        product_sku: (d.item || {}).product_sku,
                                        vendor: (d.item || {}).vendor,
                                        category: (d.item || {}).category,
                                        quantity: d.quantity,
                                        from: [that.locationsdict[d.source_location_id], that.sublocationsdict[d.source_sublocation_id]].join(" / "),
                                        to: [that.locationsdict[d.location_id], that.sublocationsdict[d.sublocation_id]].join(" / ") ,

                                        tr_id: d.tr_id,
                                        request_type: (d.item || {}).request_type
                                    }
                                    });
                                    if (that.pullist.length > 0){
                                        that.pullist_name = ("PL-"+that.pullist[0].id+"-"+that.pullist[0].date)+".csv";
                                    }
                                }
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                            that.pullist_being_loaded = false;
                        },
                        f: function(error){
                            console.log(error);
                            that.$bvToast.toast(
                                "Error loading pullist data.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                            that.pullist_being_loaded = false;
                        }
                    }
                ]
                this.pullist_being_loaded = true;
                for (var i=0; i<prereqs.length; i++){
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure"){
                        prereqs[i]["executable"](path, data, this, s, f);   
                    }
                    else {
                        prereqs[i]["executable"](path, data, s, f); 
                    }
                }
            },
            showRow: function(idx){
                if (this.picked_location == null){
                    return true
                }
                else{
                    let item = this.pullist[idx];
                    if (item.source_location_id == this.picked_location){
                        return true
                    }
                    else {
                        return false
                    }
                }
            },
            filterFromLocation: function(location_id){
                this.picked_location = location_id;
                //this.locsubs = this.locsubs.sort((a, b) => a.location_id === location_id);
            },

            sortby: function(key){
                if (this.sort_asc){
                    this.pullist = Requestor.sort(this.pullist, key)
                }
                else {
                    this.pullist = Requestor.sort_reverse(this.pullist, key)
                }
                this.sort_asc = !this.sort_asc;
            }
        },
        created: function(){
            let userDetails = localStorage.userDetails;
            if (userDetails){
                this.userDetails = JSON.parse(userDetails);

                if (this.viewdata){
                    this.name = JSON.parse(JSON.stringify(this.viewdata))
                }
                else{
                  this.name = this.$route.params.name;  
                }
                this.fetch_prereqs();
            }
        }
    }
</script>

<style scoped>
    .new_tr_label_box {
        display: inline-block;
        margin: 10px;
        width: auto;
        border: 1px solid;
        padding: 5px;
        font-size: 14px;
        background: #e5ffb1;
    }


    td {
        padding: 1px;
        font-size: 14px;
    }


    table select {
        font-size: 12px;
    }
</style>


// WEBPACK FOOTER //
// src/components/ViewPullist.vue